import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M34.578 10.69a1.88 1.88 0 0 1 .198 2.075L27.97 25.406l7.25-1.612a1.876 1.876 0 0 1 .812 3.662l-11.25 2.5a1.875 1.875 0 0 1-2.057-2.72l6.604-12.265-8.164 2.45a1.874 1.874 0 1 1-1.078-3.592l12.5-3.75a1.88 1.88 0 0 1 1.992.611"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.25 23.75a1.25 1.25 0 0 1 1.25-1.25h8.75a1.25 1.25 0 0 1 .941 2.074L15.254 32.5h5.996a1.25 1.25 0 1 1 0 2.5H12.5a1.25 1.25 0 0 1-.941-2.074L18.496 25H12.5a1.25 1.25 0 0 1-1.25-1.25"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M5.359 26.303a1.25 1.25 0 1 0-.718 2.395L8.52 29.86 3 34a1.25 1.25 0 0 0 .505 2.225l6.25 1.25a1.25 1.25 0 0 0 .49-2.45l-3.509-.703L12 30.376a1.25 1.25 0 0 0-.391-2.198z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }